/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useSnackbar, OptionsObject} from 'notistack';

export const useToast = () => {
  const {enqueueSnackbar} = useSnackbar();

  const toastSuccess = (message: string, options?: OptionsObject) => {
    enqueueSnackbar(message, {
      variant: 'success',
      autoHideDuration: 3500,
      ...options,
    });
  };

  const toastInfo = (message: string, options?: OptionsObject) => {
    enqueueSnackbar(message, {
      variant: 'info',
      autoHideDuration: 3500,
      ...options,
    });
  };

  const toastError = (message: string, options?: OptionsObject) => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: null, // Do not auto-close
      ...options,
    });
  };

  const toastWarning = (message: string, options?: OptionsObject) => {
    enqueueSnackbar(message, {
      variant: 'warning',
      autoHideDuration: 3500,
      ...options,
    });
  };

  return {toastSuccess, toastError, toastInfo, toastWarning};
};
